export const NS = 'tabs';

export const ADD_TAB = `${NS}/ADD_TAB`;
export const REMOVE_TAB = `${NS}/REMOVE_TAB`;
export const REORDER_TABS = `${NS}/REORDER_TABS`;
export const SET_COLOR = `${NS}/SET_COLOR`;
export const DUPLICATE_TAB = `${NS}/DUPLICATE_TAB`;
